import cn from "classnames";
import { useSelect } from "hooks";
/* eslint-disable react-hooks/exhaustive-deps */
import { t } from "i18next";
import { Option } from "ui/ui.types";

import { Checkbox } from "../Checkbox";
import { FormField } from "../FormField";
import { SelectListProps } from "./SelectList.types";

import styles from "./SelectList.module.scss";

const SelectList = ({
  label,
  onChange,
  options,
  errorMessage,
  disabled,
  value
}: SelectListProps) => {
  const { onSelectOption } = useSelect({
    options,
    value,
    onChange,
    multiple: true
  });

  const renderOptions = (optionsList: Option[]) => {
    return optionsList.map((option) => {
      const isChecked = Array.isArray(value) && value.includes(option.value);

      return (
        <div key={option.value} className={styles.select__option}>
          <Checkbox
            className={styles["select__checkbox-option"]}
            label={
              typeof option.label === "string" ? t(option.label) : option.label
            }
            id={option.value}
            disabled={disabled}
            checked={isChecked}
            onChange={(e) => {
              e.stopPropagation();
              onSelectOption(option.value);
            }}
          />
          {option.nestedOptions && isChecked && (
            <div className={cn(styles.select, styles.select__option__nested)}>
              {renderOptions(option.nestedOptions)}
            </div>
          )}
        </div>
      );
    });
  };

  return (
    <FormField label={label} errorMessage={errorMessage}>
      <div className={styles.select}>{renderOptions(options)}</div>
    </FormField>
  );
};

export default SelectList;
